angular.module('impactx.companyhierarchy').component('ixNestedTreeList', {
        bindings: {
            subEntry: '<',
            expand: '&'
        },
        controller: 'NestedTreeListCtrl',
        templateUrl: 'modules/companyhierarchy/templates/nested-tree-list.html'
    }
);